// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"ae1876bfab37b517","5405":"ce0e133a2e1ee4b0"}[chunkId] + ".css";
};